module.exports = __webpack_public_path__ + "img/qr_gz.57400b25.png";